import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";

import seta from '../../../assets/icon/seta-direita.png';

function AboutTwo() {
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <>
      <VisibilitySensor onChange={onChange} partialVisibility>
        <div className="sectionAboutThree">
          <div className={`item mission ${isVisible ? "visible" : ""}`}>
            <h2>Missão</h2>
            <p>
             Proteger nossos clientes , baseando-se em processos bem estruturados, desenvolvimento humano e inovações tecnologicas.
            </p>
          </div>
          <div className={`item vision ${isVisible ? "visible" : ""}`}>
            <h2>Visão</h2>
            <p>
              Ser reconhecida como empresa referencia em segurança privada no Estado de Santa Catarina.
            </p>
          </div>
          <div className={`item value ${isVisible ? "visible" : ""}`}>
            <h2>Valores</h2>
            <p><img src={seta} alt="" width={'25px'} />Honestidade</p>
            <p><img src={seta} alt="" width={'25px'} />Ética</p>
            <p><img src={seta} alt="" width={'25px'} />Comprometimento.</p>
            <p><img src={seta} alt="" width={'25px'} />Transparencia</p>
            <p><img src={seta} alt="" width={'25px'} />Qualidade</p>
            <p><img src={seta} alt="" width={'25px'} />Responsabilidade Social</p>
          </div>
        </div>
      </VisibilitySensor>
    </>
  );
}

export default AboutTwo;
